import { CatchAPIService, MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class ContactService {
  DoGetSuggestContactCode() {
    const _input: any = {
      merchantId: MerchantId(),
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/GetSuggestContactCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetSearchedContactAddress(input: any) {
    const _input: any = {
      merchantId: 0,
      taxId: input.taxId,
      branchCode: input.branchCode,
    };

    return service.peakRealTimeAPI
      .post("/api/Contact/GetSearchedContactAddress", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoCreateContact(contactTemplate: any, isAllowCreateContactDuplicate: boolean) {
    const _input: any = {
      merchantId: MerchantId(),
      contact: contactTemplate,
      isAllowCreateContactDuplicate: isAllowCreateContactDuplicate,
    };
    return service.peakRealTimeAPI
      .post("/api/Contact/CreateContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
  DoGetAllContact(isUseMainDatabase = false) {
    const _input: any = {
      merchantId: MerchantId(),
      isUseMainDatabase: isUseMainDatabase,
    };

    return service.peakExportAPI
      .post("/api/Contact/GetAllContact", _input, SetHeaderService())
      .then((res) => {
        return res;
      })
      .catch((err) => CatchAPIService(err.response));
  }
}

export default new ContactService();
